export default __webpack_public_path__ + "static/media/open_cloud_buckets.bbb6da20.svg";